export const isClientErrorResponse = (statusCode: number | null | undefined): boolean =>
	(statusCode && statusCode >= 400 && statusCode < 500) || false;
